// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ui_wrapper__JTWUA","form":"ui_form__ZwdfR"};